export default {
  recordTitle: 'Withdrawal History',
  empty: 'No withdrawals match this filter',
  filterType: 'Type',
  filterStatus: 'Status',
  st: {
    all: 'All',
    ok: 'Credited',
    pend: 'Processing',
    rej: 'Rejected',
    cancel: 'Cancelled',
  },
  detailAccount: 'Payout account',
  cancel: 'Cancel withdrawal (refund)',
  cancelling: 'Cancelling…',
  cancelOk: 'Cancelled — funds returned',
  resubmit: 'Resubmit',
  resubmitToast: 'Previous details loaded — review the payout account and submit again',
  cryptoPending: 'Review pending, will broadcast on-chain after approval',
}
